import type { User } from "lib/apollo/types"
import { setUserSegment } from "./userSegment"

export const deriveUserSegment = (
  user?: User | Record<string, never> | null
): void => {
  const userSegment = (() => {
    if (!user?.isLoggedIn) return "nonmember"
    return user?.hasMembership ? "member" : "lapsedmember"
  })()
  setUserSegment(userSegment)
}
